import { useCallback, useState, useEffect, FC, SyntheticEvent } from 'react'
import * as styles from 'components/features/coaching/advisorLandingPage/HeroSection/HeroSection.styl'
import Button from 'components/features/pfm/Button/Button'
import { ImgResponsive } from 'components/atoms/ImgResponsive/ImgResponsive'
import * as cn from 'classnames'
import Flex from 'components/atoms/Flex/Flex'

type HeroSectionProps = {
  onCTA: () => void
}

export const HeroSection: FC<HeroSectionProps> = (props) => {
  const [isShowImage, setIsShowImage] = useState(false)
  const [imageNodeOrNull, setImageLoaded] = useState<null | HTMLImageElement>(null)
  const { onCTA } = props

  const handleCta = useCallback(() => {
    onCTA()
  }, [onCTA])
  const handleImageLoaded = useCallback(async (ev: SyntheticEvent<HTMLImageElement, Event>): Promise<void> => {
    setImageLoaded(ev.target as HTMLImageElement)
  }, [])

  useEffect(() => {
    if (!imageNodeOrNull) {
      return
    }
    let isSetFlagToShowImage = true
    function showImageInUI (): void {
      if (isSetFlagToShowImage) {
        setIsShowImage(true)
      }
    }
    (imageNodeOrNull as unknown as { decode: () => Promise<void> }).decode?.().then(showImageInUI, showImageInUI) ?? showImageInUI()
    return () => {
      isSetFlagToShowImage = false
    }
  }, [imageNodeOrNull])

  return (
    <section className={ styles.heroSection }>
      <div className={ styles.content }>
        <div className={ styles.details }>
          <h1 className={ styles.headline }>
            Video chat with a
            <br />
            financial advisor
          </h1>
          <p className={ styles.summary }>
            Review your finances&nbsp;&nbsp;|&nbsp;&nbsp;Get investing advice&nbsp;&nbsp;|&nbsp;&nbsp;Discuss your retirement plans&nbsp;&nbsp;|&nbsp;&nbsp;Manage and reduce your debts&nbsp;&nbsp;|&nbsp;&nbsp;Get tax &amp; estate guidance
          </p>
          <Flex shrinkWidth gap='micro' className={ styles.buttonWrapper }>
            <Button
              text='Schedule Video Call'
              onClick={ handleCta }
              analyticsEvent={{
                category: 'page_controls-coaching_landing',
                action: 'click-schedule_cta',
                label: 'general_section',
              }}
            />
            <div className={ styles.userCounter }>
              400,000+ members
            </div>
          </Flex>
        </div>
        <div className={ cn(styles.img, isShowImage && styles.visible) }>
          <ImgResponsive src='/images/coaching/devices.png' width='100%' className={ styles.imgAspectRatio } decoding='async' onLoad={ handleImageLoaded } />
        </div>
      </div>
    </section>
  )
}
